import { FC } from 'react';
import { WithScope } from '@mews-commander/types';
import { SearchType } from '@mews-commander/enums';
import { createZodFormResolver, lt, Form } from '@mews/framework';
import { useCommanderSelector } from '@mews-commander/utils';
import { isCurrentProfileEnabledToManageCustomers } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { FormLayout } from '../../FormLayout';
import { SearchHookField } from '../../../../../components/form/hookFields';
import { BookerFormKeys, BookerFormSchema, BookerFormValues } from './types';
import { getBookerFormInitialValues } from './selectors';
import { useUpdateBookerMutation } from './useUpdateBookerMutation';

interface BookerFormProps extends WithScope {
    reservationIds: string[];
    onSuccess: () => void;
}

export const BookerForm: FC<BookerFormProps> = ({ scope, reservationIds, onSuccess }: BookerFormProps) => {
    const defaultValues = useCommanderSelector((state) => getBookerFormInitialValues(state, { scope }));
    const canManageCustomers = useCommanderSelector((state) => isCurrentProfileEnabledToManageCustomers(state));
    const mutation = useUpdateBookerMutation(reservationIds);

    const handleSubmit = (values: BookerFormValues) => {
        mutation.mutate(values, { onSuccess });
    };

    return (
        <Form
            onSubmit={handleSubmit}
            resolver={createZodFormResolver(BookerFormSchema)}
            values={defaultValues}
            dataTestForm="booker-form"
        >
            <FormLayout loading={mutation.isPending} vertical={false}>
                <SearchHookField
                    data-test-id={BookerFormKeys.customerId}
                    newEntity={canManageCustomers}
                    name={BookerFormKeys.customerId}
                    label={lt('Booker')}
                    searchTypes={[SearchType.Customer]}
                />
            </FormLayout>
        </Form>
    );
};
